import Vue from 'vue';

export const round = (num: number, precision = 1): number => Number(num.toFixed(precision));

Vue.filter('round', (number: number, precision = 1): number => round(number, precision));

Vue.filter('fixed', (number: number, precision = 1): string => number.toFixed(precision));
